module.exports = "<!--Footer Starts-->\n<footer>\n  <div class=\"container-fluid\">\n    <p class=\"copyright text-center\">\n      Copyright &copy; {{currentDate | date: 'yyyy'}} Pharma Business Review. All rights reserved.\n    </p>\n  </div>\n</footer>\n<!--Footer Ends-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main